"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authenticator = exports.AUTH_CONFIG_STORAGE_KEY = void 0;
var React = require("react");
var auth_1 = require("@aws-amplify/auth");
var core_1 = require("@aws-amplify/core");
var AuthConfirmSignIn_1 = require("./AuthConfirmSignIn");
var AuthConfirmSignUp_1 = require("./AuthConfirmSignUp");
var AuthForgotPassword_1 = require("./AuthForgotPassword");
var AuthRequireNewPassword_1 = require("./AuthRequireNewPassword");
var AuthResetPassword_1 = require("./AuthResetPassword");
var AuthSignIn_1 = require("./AuthSignIn");
var AuthTOTPSetup_1 = require("./AuthTOTPSetup");
var AuthVerifyContactCodeInput_1 = require("./AuthVerifyContactCodeInput");
var AuthVerifyContactCodeRequest_1 = require("./AuthVerifyContactCodeRequest");
var getSearchParams_1 = require("../utils/getSearchParams");
var hasKeys_1 = require("../utils/hasKeys");
exports.AUTH_CONFIG_STORAGE_KEY = 'congito-auth-organization';
var Authenticator = (function (_super) {
    __extends(Authenticator, _super);
    function Authenticator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._searchParams = getSearchParams_1.getSearchParams();
        _this._storage = new core_1.StorageHelper().getStorage();
        _this.state = __assign({ additionalData: undefined, authState: undefined, authData: undefined, groups: undefined }, _this._getInitialConfigState());
        _this.handleChangeState = function (authState, retain) {
            if (retain === void 0) { retain = false; }
            _this._changeState({
                authState: authState,
                authData: retain ? _this.state.authData : undefined,
            });
        };
        _this.handleCompleteNewPasswordRequired = function (_a) {
            var password = _a.password, passwordRepeat = _a.passwordRepeat, attributes = __rest(_a, ["password", "passwordRepeat"]);
            var user = _this.state.authData;
            var requiredAttributes = (user.challengeParam.requiredAttributes || []).reduce(function (acc, cur) {
                acc[cur] = attributes[cur];
                return acc;
            }, {});
            return auth_1.default.completeNewPassword(user, password, requiredAttributes).then(function (user) { return _this._respondToChallenge(user); });
        };
        _this.handleConfirmSignIn = function (_a) {
            var code = _a.code;
            var user = _this.state.authData;
            var mfaType = user.challengeName === 'SOFTWARE_TOKEN_MFA' ? 'SOFTWARE_TOKEN_MFA' : null;
            return auth_1.default.confirmSignIn(user, code, mfaType).then(function () {
                return _this._checkContact(user);
            });
        };
        _this.handleRequestResetPasswordCode = function (_a) {
            var organization = _a.organization, username = _a.username;
            return _this._resolveConfig(organization).then(function (config) {
                return auth_1.default.forgotPassword(username).then(function (data) {
                    _this._changeState({
                        authState: 'resetPassword',
                        additionalData: { organization: organization, username: username },
                    });
                });
            });
        };
        _this.handleRequestContactVerificationCode = function (attribute) {
            return auth_1.default.verifyCurrentUserAttribute(attribute).then(function (data) {
                _this._changeState({
                    authState: 'verifyContact',
                    authData: _this.state.authData,
                    additionalData: { attribute: attribute },
                });
            });
        };
        _this.handleResetPassword = function (_a) {
            var organization = _a.organization, username = _a.username, code = _a.code, password = _a.password;
            return _this._resolveConfig(organization).then(function (organization) {
                return auth_1.default.forgotPasswordSubmit(username, code, password).then(function (data) {
                    _this._changeState({ authState: 'signIn' });
                });
            });
        };
        _this.handleSignIn = function (_a) {
            var organization = _a.organization, username = _a.username, password = _a.password;
            return _this._resolveConfig(organization)
                .then(function (organization) {
                return auth_1.default.signIn(username, password).then(function (user) {
                    return _this._respondToChallenge(user);
                });
            })
                .catch(function (err) {
                if (err.code === 'UserNotConfirmedException') {
                    _this._changeState({ authState: 'confirmSignUp' });
                }
                else {
                    return Promise.reject(err);
                }
            });
        };
        _this.handleSignOut = function () {
            auth_1.default.signOut()
                .then(function () { return _this._changeState({ authState: 'signedOut' }); })
                .catch(function (err) {
                console.error(err);
            });
            fetch('https://backoffice-api.element.in/logout', {
                method: 'POST',
                credentials: 'include',
            }).catch(function (err) {
                console.error(err);
            });
        };
        _this.handleSkipVerifyContact = function () { return _this._checkUser(); };
        _this.handleTOTPSetup = function (authData) {
            var user = authData || _this.state.authData;
            return auth_1.default.setPreferredMFA(user, 'NOMFA')
                .catch(function () { return null; })
                .then(function () {
                return auth_1.default.setupTOTP(user).then(function (data) {
                    return {
                        link: "otpauth://totp/AWSCognito:" + user.username + "?secret=" + data + "&issuer=ELEMENT%20Insurance%20AG",
                        secret: data,
                    };
                });
            });
        };
        _this.handleVerifyContact = function (_a) {
            var attribute = _a.attribute, code = _a.code;
            return auth_1.default.verifyCurrentUserAttributeSubmit(attribute, code).then(function (data) {
                return _this._checkUser();
            });
        };
        _this.handleVerifyTOTPSetup = function (_a) {
            var code = _a.code;
            var user = _this.state.authData;
            return auth_1.default.verifyTotpToken(user, code).then(function () {
                return auth_1.default.setPreferredMFA(user, 'TOTP').then(function () { return _this._checkContact(user); });
            });
        };
        return _this;
    }
    Authenticator.prototype.componentDidMount = function () {
        this._checkUser(true);
    };
    Authenticator.prototype.render = function () {
        var signedIn = this.state.authState === 'signedIn';
        var props = Object.assign({
            onChangeState: this.handleChangeState,
            onCompleteNewPasswordRequired: this.handleCompleteNewPasswordRequired,
            onConfirmSignIn: this.handleConfirmSignIn,
            onRequestResetPasswordCode: this.handleRequestResetPasswordCode,
            onRequestContactVerificationCode: this
                .handleRequestContactVerificationCode,
            onResetPassword: this.handleResetPassword,
            onSignIn: this.handleSignIn,
            onSignOut: this.handleSignOut,
            onSkipVerifyContact: this.handleSkipVerifyContact,
            onTOTPSetup: this.handleTOTPSetup,
            onVerifyContact: this.handleVerifyContact,
            onVerifyTOTPSetup: this.handleVerifyTOTPSetup,
            Components: this.props.Components,
        }, this.state);
        if (signedIn) {
            return this.props.children(props);
        }
        return (React.createElement(React.Fragment, { key: this.state.authState },
            React.createElement(AuthConfirmSignIn_1.AuthConfirmSignIn, __assign({}, props)),
            React.createElement(AuthConfirmSignUp_1.AuthConfirmSignUp, __assign({}, props)),
            React.createElement(AuthForgotPassword_1.AuthForgotPassword, __assign({}, props)),
            React.createElement(AuthRequireNewPassword_1.AuthRequireNewPassword, __assign({}, props)),
            React.createElement(AuthResetPassword_1.AuthResetPassword, __assign({}, props)),
            React.createElement(AuthSignIn_1.AuthSignIn, __assign({}, props)),
            React.createElement(AuthTOTPSetup_1.AuthTOTPSetup, __assign({}, props)),
            React.createElement(AuthVerifyContactCodeInput_1.AuthVerifyContactCodeInput, __assign({}, props)),
            React.createElement(AuthVerifyContactCodeRequest_1.AuthVerifyContactCodeRequest, __assign({}, props))));
    };
    Authenticator.prototype._checkContact = function (user) {
        var _this = this;
        return auth_1.default.verifiedContact(user).then(function (data) {
            if (hasKeys_1.hasKeys(data.verified) && !hasKeys_1.hasKeys(data.unverified)) {
                return _this._checkUser();
            }
            else {
                user = Object.assign(user, data);
                _this._changeState({ authState: 'verifyContact', authData: user });
            }
        });
    };
    Authenticator.prototype._changeState = function (_a) {
        var authState = _a.authState, authData = _a.authData, additionalData = _a.additionalData;
        if (authState === 'signedOut') {
            authState = 'signIn';
        }
        var newState = {
            authState: authState,
            authData: authData,
            additionalData: additionalData,
            groups: authData ? this._getUserGroups(authData) : undefined,
        };
        if (authState === 'signIn' && this.state.hasMultipleOrganizations) {
            Object.assign(newState, this._getInitialConfigState());
        }
        this.setState(newState);
    };
    Authenticator.prototype._checkUser = function (initial) {
        var _this = this;
        if (initial === void 0) { initial = false; }
        return this._resolveConfig(this.state.organization || this._storage.getItem(exports.AUTH_CONFIG_STORAGE_KEY))
            .then(function (config) {
            return auth_1.default.currentAuthenticatedUser().then(function (user) {
                _this._changeState({ authState: 'signedIn', authData: user });
            });
        })
            .catch(function (err) {
            if (err) {
                return _this.handleSignOut();
            }
            if (initial) {
                var auth = _this._searchParams.auth;
                if (auth === 'resetPassword' && _this._searchParams.username) {
                    var _a = _this._searchParams, organization = _a.organization, username = _a.username;
                    return _this._changeState({
                        authState: 'resetPassword',
                        additionalData: { organization: organization, username: username },
                    });
                }
            }
            _this._changeState({ authState: 'signIn' });
        });
    };
    Authenticator.prototype._getInitialConfigState = function () {
        if (Object.keys(this.props.config).length === 1) {
            var organization = Object.keys(this.props.config)[0];
            this._setConfig(organization);
            return {
                hasMultipleOrganizations: false,
                organization: organization,
                requiresConfiguration: false,
            };
        }
        else {
            var search = new URLSearchParams(window.location.search).get('org');
            var storage = this._storage.getItem(exports.AUTH_CONFIG_STORAGE_KEY);
            var organization = void 0;
            if (search && /^[\w-]+$/.test(search)) {
                organization = search;
            }
            else if (storage && /^[\w-]+$/.test(storage)) {
                organization = storage;
            }
            return {
                organization: organization,
                hasMultipleOrganizations: true,
                requiresConfiguration: true,
            };
        }
    };
    Authenticator.prototype._getUserGroups = function (user) {
        var session = user.getSignInUserSession();
        if (session) {
            var idToken = session.getIdToken();
            var payload = idToken.decodePayload();
            return payload['cognito:groups'] || [];
        }
        return undefined;
    };
    Authenticator.prototype._resolveConfig = function (organization) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!organization) {
                return reject();
            }
            if (!_this.state.requiresConfiguration &&
                organization === _this.state.organization) {
                return resolve(_this.state.organization);
            }
            var configured = _this._setConfig(organization);
            if (configured) {
                _this.setState({ organization: organization, requiresConfiguration: false });
                resolve(organization);
            }
            else {
                reject({ message: 'Organization does not exist' });
            }
        });
    };
    Authenticator.prototype._respondToChallenge = function (user) {
        var _this = this;
        var challenge = user.challengeName;
        if (challenge === 'SMS_MFA' || challenge === 'SOFTWARE_TOKEN_MFA') {
            return this._changeState({ authState: 'confirmSignIn', authData: user });
        }
        if (challenge === 'NEW_PASSWORD_REQUIRED') {
            return this._changeState({
                authState: 'requireNewPassword',
                authData: user,
            });
        }
        if (challenge === 'MFA_SETUP' ||
            shouldForceMFA(this.props.requireMfa, user.preferredMFA)) {
            return this.handleTOTPSetup(user).then(function (additionalData) {
                _this._changeState({
                    additionalData: additionalData,
                    authState: 'TOTPSetup',
                    authData: user,
                });
            });
        }
        return this._checkContact(user);
    };
    Authenticator.prototype._setConfig = function (organization) {
        var config = this.props.config[organization];
        if (config) {
            auth_1.default.configure(config);
            this._storage.setItem(exports.AUTH_CONFIG_STORAGE_KEY, organization);
            return true;
        }
        else {
            return false;
        }
    };
    Authenticator.defaultProps = {
        requireMfa: false,
    };
    return Authenticator;
}(React.Component));
exports.Authenticator = Authenticator;
function shouldForceMFA(force, preferredMFA) {
    if (force) {
        return !preferredMFA || preferredMFA === 'NOMFA';
    }
    return false;
}
//# sourceMappingURL=Authenticator.js.map